import {
  Create,
  TextInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  BooleanInput,
  useRedirect,
  useNotify,
  useRefresh,
  SaveButton,
  Toolbar,
  NumberInput,
} from "react-admin";

import { useCreateStyles } from "../__common/MyStyles";
import { MyCreateActions } from "../__common/MyCreateActions";
import { sleep } from "../../common/js/Functions";

import { parse } from "query-string";

import { PositionGrid } from "./PositionGrid";
import { AutoCompleteIsolateCode } from "./AutoCompleteIsolateCode";


const IsolateCreateToolbar = (props) => {
  const redirect = useRedirect();
  const notify = useNotify();
  const refresh = useRefresh();

  return (
    <Toolbar {...props}>
      <SaveButton
        label="Save"
        submitOnEnter={false}
        onSuccess={({ data }) => {
          // if not empty, redirect to the sample show view
          if (data.id_sample !== "") {
            notify(`Isolate created, redirecting to "samples/isolates" view`);
            sleep(2000).then(() => {
              redirect(`/samples/${data.id_sample}/show/isolates`);
              refresh();
            });
          } else {
            notify(`Isolate created, redirecting to isolates list`);
            sleep(2000).then(() => {
              redirect(`/isolates`);
              refresh();
            });
          }
        }}
      />
      <span>&nbsp;</span>
      <SaveButton
        label="Save & add another"
        onSuccess={({ data }) => {
          notify(`Isolate created, redirecting to "create" view`);
          sleep(2000).then(() => {
            redirect(
              `/isolates/create?id_sample=${data.id_sample}&id_culture=${data.id_culture}`
            );
            refresh();
          });
        }}
        // transform={(data) => ({
        //   ...data,
        //   code: `${props.id_sample}.${data.id_culture}.${data.code}`, // TODO HACER QUE ESTO SE VEA EN EL CAMPO CODIGO
        // })}
        submitOnEnter={true}
      />
    </Toolbar>
  );
};

export const IsolatesCreate = (props) => {
  const classes = useCreateStyles();
  const { id_sample: id_sample_string } = parse(props.location.search);
  const id_sample = id_sample_string ? parseInt(id_sample_string, 10) : "";

  //const { id_culture: id_culture_string } = parse(props.location.search);
  //const id_culture = id_culture_string ? parseInt(id_culture_string, 10) : "";

 

  return (
      <Create {...props} actions={<MyCreateActions />} classes={classes}>
        <SimpleForm
          initialValues={id_sample ? { id_sample } : {}}
          toolbar={<IsolateCreateToolbar id_sample={id_sample} />}
        >
          <AutoCompleteIsolateCode id_sample={id_sample}/>
          {/* <FormDataConsumer>
            {({ formData, dispatch, ...rest }) => {
              console.log(formData);
              formData.code = `${formData.code_sample}.${formData.code_culture}.${formData.isolate}`;
            }}
          </FormDataConsumer> */}
          <BooleanInput source="is_isolated" />
          <BooleanInput source="has_sequence" />
          <BooleanInput source="has_picture" />
          <TextInput source="notes" multiline minRows={6} />

          {/* Phenotypes */}
          <div className="">PHENOTYPE</div>
          <TextInput source="isolates_phenotype.size" label="Size" />
          <TextInput source="isolates_phenotype.shape" label="Shape" />
          <TextInput source="isolates_phenotype.elevation" label="Elevation" />
          <TextInput source="isolates_phenotype.border" label="Border" />
          <TextInput source="isolates_phenotype.surface" label="Surface" />
          <TextInput source="isolates_phenotype.color" label="Color" />
          <TextInput
            source="isolates_phenotype.observation"
            label="Observation"
            multiline
            minRows={6}
          />

          {/* Storage */}
          <div className="">STORAGE</div>
          <TextInput
            source="isolates_storages.cryobox_name"
            label="Cryobox name"
          />
          <NumberInput
            source="isolates_storages.cryobox_size"
            label="Size"
            initialValue="81"
          />
          <TextInput
            source="isolates_storages.cryobox_position"
            label="Position"
          />
          <PositionGrid></PositionGrid>
          <ReferenceInput
            perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
            label="Storage"
            source="isolates_storages.id_storage"
            reference="storages"
          >
            <SelectInput optionText="storage" />
          </ReferenceInput>
          <TextInput
            source="isolates_storages.notes"
            label="Notes"
            multiline
            minRows={6}
          />
          {/* <MultipleSelectCheckmarks values={antibioticos} state={setAntibioticos}></MultipleSelectCheckmarks>*/}
          <br></br>
          <br></br>
        </SimpleForm>
      </Create>
  );
};

//function createData(name, calories, fat, carbs, protein) {
//  return { name, calories, fat, carbs, protein };
// }

